// extracted by mini-css-extract-plugin
export default {"carretteImg":"slider_carretteImg__Hxy1C","carret":"slider_carret__wreb3","slider-control-bottomcenter":"slider_slider-control-bottomcenter__9Lm85"};